export const SET_TABLE_MODE = "extensions/SET_TABLE_MODE";
export const SET_DETAILS_IS_ACTIVE = "extensions/SET_DETAILS_IS_ACTIVE";
export const SET_DETAILS_ID = "extensions/SET_DETAILS_ID";
export const SET_FILTERS_TAB_IS_ACTIVE = "extensions/SET_FILTERS_TAB_IS_ACTIVE";
export const SET_PREFERENCES_MODAL_IS_ACTIVE =
  "extensions/SET_PREFERENCES_MODAL_IS_ACTIVE";
export const SET_PREFERENCES_ID = "extensions/SET_PREFERENCES_ID";

// FILTERS
export const SET_SEARCH_FILTER = "extensions/SET_SEARCH_FILTER";
export const SET_ACTIVE_FILTERS = "extensions/SET_ACTIVE_FILTERS";
export const CLEAR_FILTERS = "extensions/CLEAR_FILTERS";
